/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import {render} from '@canvas/react'
import ready from '@instructure/ready'
import {useScope as createI18nScope} from '@canvas/i18n'
import type {GlobalEnv} from '@canvas/global/env/GlobalEnv'
import {ErrorBoundary} from '@instructure/platform-error-boundary'
import {GenericErrorPage} from '@instructure/platform-generic-error-page'
import {reportError, canvasErrorPageTranslations} from '@canvas/error-page-utils'
import errorShipUrl from '@instructure/platform-images/assets/ErrorShip.svg'
import {QueryClientProvider} from '@tanstack/react-query'
import {queryClient} from '@instructure/platform-query'
import {App} from './react/App'

const I18n = createI18nScope('youtube_migration')

const ENV = window.ENV as GlobalEnv

ready(() => {
  const container = document.getElementById('content')

  if (!ENV.COURSE_ID) {
    console.error('Course ID is required')
    return
  }

  if (container) {
    render(
      <ErrorBoundary
        errorComponent={
          <GenericErrorPage
            imageUrl={errorShipUrl}
            onReportError={reportError}
            translations={canvasErrorPageTranslations}
            errorCategory={I18n.t('Youtube Migration Error Page')}
          />
        }
      >
        <QueryClientProvider client={queryClient}>
          <App courseId={ENV.COURSE_ID} />
        </QueryClientProvider>
      </ErrorBoundary>,
      container,
    )
  }
})
